// extracted by mini-css-extract-plugin
module.exports = {"container":"SubAssembly_container__1_gC0","tableView":"SubAssembly_tableView__2IptB","activeTrue":"SubAssembly_activeTrue__379qe","activeFalse":"SubAssembly_activeFalse__2eX_Z"};